export {default as scssVariables} from "!!sass-variable-loader!../../../styles/variables.scss";
export {default as scssColors} from "!!sass-variable-loader!../../../styles/colors.scss";

export const wwwPrefix = document.body.getAttribute("data-www-prefix");
export const apiPrefix = document.body.getAttribute("data-api-prefix");
export const javascriptVersion = document.body.getAttribute("data-javascript-version");
export const cssVersion = document.body.getAttribute("data-css-version");
export const supportsBrowserHistory = true;//TODO: fix this line and all its usages

/**
 * Join a list of strings into a url separated by slashes.
 * 
 * @param {...string} urls 
 * @returns {string}
 */
export function urlJoin(...urls) {
    let url = "/";
    for (const u of urls) {
        if (u.startsWith("http:")) {
            url = u;
        } else if (u.startsWith("https:")) {
            url = u;
        } else if (url.endsWith("/") && u.startsWith("/")) {
            url += u.substring(1);
        } else if (url.endsWith("/")) {
            url += u;
        } else {
            url += `/${u}`;
        }
    }
    return url;
}

/**
 * Formats a url into standard shape with prefix, etc.
 * 
 * @param {string} url 
 * @param {?Object} queryParameters
 * @returns {string}
 */
export function makeUrl(url, queryParameters = undefined) {
    let result;
    if (wwwPrefix) {
        result = urlJoin(wwwPrefix, url);
    } else {
        result = urlJoin(url);
    }

    let hasQueryParameters = false;
    if (queryParameters) {
        for (const p in queryParameters) {
            if (Object.prototype.hasOwnProperty(queryParameters, p) && queryParameters[p] != null) {
                hasQueryParameters = true;
                break;
            }
        }
    }

    if (hasQueryParameters) {
        result = `${result}?${Object.entries(queryParameters).filter(kv => kv[1] != null).map(([key, value]) => `${key}=${encodeURIComponent(value)}`).join("&")}`;
    }
    
    return result;
}

/**
 * Formats a url directed at the api into standard shape with prefix, etc.
 * 
 * @param {string} url 
 * @returns {string}
 */
export function makeApiUrl(url) {
    if (apiPrefix) {
        return urlJoin(apiPrefix, url);
    } else {
        return urlJoin(url);
    }
}